import { Link } from 'react-router-dom';
import { Scale, Phone, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0B1C2D] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-[#C6A34A] rounded-sm flex items-center justify-center">
                <Scale className="w-7 h-7 text-[#0B1C2D]" />
              </div>
              <div>
                <span 
                  className="text-2xl font-semibold block"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  Juris Bihar
                </span>
                <span className="text-sm text-gray-400">
                  Chambers of Adv. Ajeet Narayan Sinha
                </span>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed mb-6 max-w-md">
              Providing dedicated civil litigation services in Patna, Bihar with almost 
              four decades of experience before the Patna High Court and other civil courts.
            </p>
            <div className="w-16 h-1 bg-[#C6A34A]"></div>
          </div>

          {/* Contact Column - NAP Consistency */}
          <div>
            <h3 
              className="text-lg font-semibold mb-6 text-[#C6A34A]"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Contact
            </h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#C6A34A] mt-1 flex-shrink-0" />
                <address className="not-italic text-gray-400 text-sm leading-relaxed">
                  <strong className="text-white">Adv. Ajeet Narayan Sinha</strong><br />
                  306, Devendra Residency,<br />
                  Kankarbagh Main Road,<br />
                  Patna, Bihar - 800026
                </address>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-[#C6A34A] flex-shrink-0" />
                <a 
                  href="tel:+919431078694" 
                  className="text-gray-400 hover:text-[#C6A34A] transition-colors"
                  data-testid="footer-phone"
                >
                  +91 9431078694
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-[#C6A34A] flex-shrink-0" />
                <a 
                  href="mailto:ajeet.sinha@jurisbihar.com" 
                  className="text-gray-400 hover:text-[#C6A34A] transition-colors"
                  data-testid="footer-email"
                >
                  ajeet.sinha@jurisbihar.com
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 
              className="text-lg font-semibold mb-6 text-[#C6A34A]"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Legal
            </h3>
            <nav className="space-y-3">
              <Link 
                to="/disclaimer" 
                className="block text-gray-400 hover:text-[#C6A34A] transition-colors"
                data-testid="footer-disclaimer-link"
              >
                Disclaimer
              </Link>
              <Link 
                to="/privacy-policy" 
                className="block text-gray-400 hover:text-[#C6A34A] transition-colors"
                data-testid="footer-privacy-link"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/terms" 
                className="block text-gray-400 hover:text-[#C6A34A] transition-colors"
                data-testid="footer-terms-link"
              >
                Terms & Conditions
              </Link>
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {currentYear} Chambers of Adv. Ajeet Narayan Sinha. All rights reserved.
            </p>
            <p className="text-gray-500 text-xs text-center md:text-right">
              Bar Council of India compliant. This website is meant to provide information only.
            </p>
          </div>
        </div>
      </div>

      {/* Schema Markup for Local Business - Hidden */}
      <script type="application/ld+json" className="schema-markup" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LegalService",
          "name": "Chambers of Adv. Ajeet Narayan Sinha",
          "alternateName": "Juris Bihar",
          "url": "https://jurisbihar.com",
          "telephone": "+919431078694",
          "email": "ajeet.sinha@jurisbihar.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "306, Devendra Residency, Kankarbagh Main Road",
            "addressLocality": "Patna",
            "addressRegion": "Bihar",
            "postalCode": "800026",
            "addressCountry": "IN"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "25.5941",
            "longitude": "85.1376"
          },
          "areaServed": {
            "@type": "State",
            "name": "Bihar"
          },
          "priceRange": "$$",
          "openingHours": "Mo-Sa 10:00-18:00"
        })
      }} />
    </footer>
  );
};
